// Numbers fixed by docs/protocol.md and docs/SPEC.md. Change them there first.
/** Envelopes with sentAt further than this from the receiver's clock are rejected (stale or badly skewed). */
export const ENVELOPE_MAX_SKEW_MS = 10 * 60_000;
/** A command is fresh only if the daemon's clock minus the card stamp is at most this. */
export const COMMAND_FRESH_MS = 60_000;
/** A pairing invite dies after this. */
export const PAIRING_TTL_MS = 10 * 60_000;
/** Wrong SAS entries allowed before pairing is cancelled. */
export const SAS_ATTEMPTS = 3;
/** Typed reply limit. */
export const MAX_TEXT_CHARS = 2000;
/** Relay-auth and account-creation timestamps must be this close to the relay's clock. */
export const AUTH_MAX_SKEW_MS = 5 * 60_000;
/** The 2-second hold on the answering device (SPEC 5.4). */
export const HOLD_MS = 2000;
/** Longest a hook may hold a question for the phone before releasing it to the desk (SPEC 3.11). */
export const HOOK_HOLD_MAX_MS = 10 * 60_000;
/** No keyboard/mouse input for this long means a hook may hold a question for the phone (SPEC 3.11). */
export const HOLD_IDLE_MS = 60_000;
/** Input within this window counts as "at the desk" for push suppression (SPEC 3.5). */
export const AT_DESK_MS = 3 * 60_000;
/** Web Push time-to-live (SPEC section 4). */
export const PUSH_TTL_S = 300;
/** Cap on one state snapshot. */
export const STATE_MAX_BYTES = 64 * 1024;
//# sourceMappingURL=limits.js.map